import throttle from 'lodash.throttle';
import { isInViewport } from './utils';

const $getImages     = () => $('.js-lazy');
const $lazyContainer = $('.js-lazy-images');
const $window        = $(window);

const hasImageSrc = (index, image) => $(image).data('src') != null;

const $lazyImages = () => $getImages().filter( hasImageSrc );

const setAsActive = (event) => {
  const $imageContainer = $(event.currentTarget).parent();
  $imageContainer.removeClass('is-loading');
  $imageContainer.addClass('is-loaded');

};

const loadImage = (image) => {
  if ( !isInViewport(image) ) {return}

  let imageSrc = image.getAttribute('data-src');
  if ( imageSrc ) {
      image.src = imageSrc;
      image.onload = setAsActive;
      image.removeAttribute('data-src');
  }
};

const lazyLoadImages = () => {
  $lazyImages().each( (index, image) => { loadImage(image) } );
};

const throttledLazyLoad = throttle(lazyLoadImages, 200);

const setupLazy = () => {

  $window.on('load', throttledLazyLoad);
  $window.on('scroll', throttledLazyLoad);
  $window.on('resize', throttledLazyLoad);
  $window.on('touchmove', throttledLazyLoad);
};

if ($lazyContainer.length > 0) {
  setupLazy();
}

lazyLoadImages();



// WEBPACK FOOTER //
// ./src/_assets/js/modules/imageLoader.js